import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@20.19.23_@vue+compiler-sfc@3.5.29_db0@0.3_d57241d6da81c9f7a2819d13c1af0dcb/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}